import GamePastStrip, { type GamePastItem } from "./GamePastStrip";

interface Props {
  icon: string;
  emptyTitle: string;
  emptyDesc: string;
  registerLabel: string;
  onRegister: () => void;
  pastItems: GamePastItem[];
  /** 오른쪽 지난 기록 라벨 */
  pastTitle?: string;
  pastEmptyText?: string;
}

// 메인 홈 게임(내가쏜다 · 가위바위보 · 줄다리기) 공통 «빈 상태».
// 열린 판이 없을 때 섹션을 크게 잡지 않고,
// 왼쪽에 안내 + 등록 버튼, 오른쪽에 지난 기록 썸네일 몇 개만 간단히 표시한다.
export default function GameSectionEmpty({
  icon,
  emptyTitle,
  emptyDesc,
  registerLabel,
  onRegister,
  pastItems,
  pastTitle,
  pastEmptyText,
}: Props) {
  return (
    <div className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="flex flex-col gap-5 lg:flex-row lg:items-center">
        <div className="lg:w-[280px] lg:shrink-0">
          <div className="flex items-start gap-3">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-background-100 text-xl text-foreground-400">
              <i className={icon} aria-hidden="true"></i>
            </span>
            <div>
              <p className="font-heading text-base font-semibold text-foreground-800">
                {emptyTitle}
              </p>
              <p className="mt-1 text-sm text-foreground-500">{emptyDesc}</p>
            </div>
          </div>
          <button
            type="button"
            onClick={onRegister}
            className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600"
          >
            <i className="ri-add-line text-base" aria-hidden="true"></i>
            {registerLabel}
          </button>
        </div>

        <GamePastStrip
          items={pastItems}
          title={pastTitle}
          emptyText={pastEmptyText}
        />
      </div>
    </div>
  );
}